import qs from 'qs';
import Cookies from 'js-cookie';

const USER_AGENT_COOKIE_NAME = 'ClientPlatform';
export const USER_AGENT_COOKIE_NAME_VALUE_MOBILE_WEBVIEW_REGEX = /^(ios|android)-.*$/;

/**
 * Ticket https://gitlab.com/d3454/core/douleutaras/-/issues/1715
 * Create a cookie and set its value to the passed value of query param
 */
export const createUserAgentCookie = () => {
  const getParamsString = window.location.search.substr(1);
  const params = qs.parse(getParamsString);

  if (params.ClientPlatform && typeof params.ClientPlatform === 'string') {
    Cookies.set(USER_AGENT_COOKIE_NAME, params.ClientPlatform);
  }
};

export const isMobileWebviewUserAgent = () => {
  const userAgentCookie = Cookies.get(USER_AGENT_COOKIE_NAME);

  return USER_AGENT_COOKIE_NAME_VALUE_MOBILE_WEBVIEW_REGEX.test(userAgentCookie);
};
